import { http } from "services";

export const List = ({ params }) =>
  http.request.post("/v1/gov-function/open-function/pageable", {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
  });

export const Single = ({ id }) =>
  http.request.get(`/v1/gov-function/open-function/new-version/${id}`);

export const FunctionNames = ({ params }) =>
  http.request.post(
    "/v1/gov-function/open-function/names/without-function-register/pageable",
    {
      per_page: params.perPage,
      page: params.page,
      sort: params.sort,
      search: params.filter,
    },
  );

export const FunctionNamesByOrg = ({ params }) =>
  http.request.post("/v1/gov-function/open-function/names/by/org/pageable", {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
  });

export const FunctionNamesByLevel = ({ params }) =>
  http.request.post("/v1/gov-function/open-function/names/by/level/pageable", {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
  });

export const FunctionTask = ({ params }) =>
  http.request.post("/v1/gov-function/function-tasks/pageable", {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
  });

export const FunctionTasksByOrg = ({ params }) =>
  http.request.post("/v1/gov-function/function-tasks/organization/pageable", {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter,
  });

export const StageSteps = ({ id }) =>
  http.request.get(`/v1/gov-function/open-function/stage-step/${id}`);
